module.exports = __webpack_public_path__ + "img/vu.972726b3.png";